import { isBrowser } from '@shared/utils-universal/is-browser';

export const getScrollY = () => {
  if (!isBrowser() || !window.pageYOffset) {
    return 0;
  }
  return window.pageYOffset;
};

export const getInnerWidth = () => {
  if (!isBrowser() || !window.innerWidth) {
    return 0;
  }

  return window.innerWidth;
};
